/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=3e8e26d7&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3e8e26d7&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "F:\\php-project\\admin_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8e26d7"],['__file',"library/layouts/VabLayoutCommon/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e8e26d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e8e26d7', __exports__)) {
    api.reload('3e8e26d7', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3e8e26d7&scoped=true", () => {
    api.rerender('3e8e26d7', render)
  })

}


export default __exports__